export class CargoEntity {
  _id: any;
  idDB: any;
  nombre: string = "";
  A: CategoriaTienda = new CategoriaTienda();
  AA: CategoriaTienda = new CategoriaTienda();
  AAA: CategoriaTienda = new CategoriaTienda();
  grupo: GrupoCargoEntity;
  negocio:string = ""


}

export class CategoriaTienda {
  porcentajes: PorcentajeComision[] = [];
}

export class PorcentajeComision {
  minimo: number = 0;
  maximo: number = 0;
  valor: number = 0;
}

export class GrupoCargoEntity {
  _id:any;
  nombre:string;
  tiendas:string[] = [];
}
